import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  LobsterMasterApi,
  type PostInternalLabelMasterRequestBody,
} from '@ulysses-inc/harami_api_client'
import { useSnackbar } from 'src/components/snackbar/useSnackbar'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { getLobsterApiErrorDetail } from './getLobsterApiErrorDetail'
import { labelMasterQueryKeys } from './queryKeys'

export const useSaveLabelMaster = (type: 'create' | 'update') => {
  const queryClient = useQueryClient()
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbar()

  return useMutation({
    mutationFn: (data: PostInternalLabelMasterRequestBody) =>
      baseClient.getApi(LobsterMasterApi).postInternalLabelMasters({
        postInternalLabelMasterRequestBody: data,
      }),
    onSuccess: () => {
      const successMessage =
        type === 'create'
          ? 'ラベルマスタを作成しました'
          : 'ラベルマスタを保存しました'
      showSuccessSnackbar(successMessage)

      queryClient.invalidateQueries({
        queryKey: labelMasterQueryKeys.labelMasters.all,
      })
    },
    onError: async error => {
      const detail = await getLobsterApiErrorDetail(error)
      const fallbackMessage =
        type === 'create'
          ? 'ラベルマスタの作成に失敗しました。しばらく経ってから再度お試しください。'
          : 'ラベルマスタの保存に失敗しました。しばらく経ってから再度お試しください。'

      const errorMessage = detail ?? fallbackMessage
      showErrorSnackbar(errorMessage)
    },
  })
}
